import { render, staticRenderFns } from "./CopyCandidateFrom.vue?vue&type=template&id=b715c692&"
import script from "./CopyCandidateFrom.vue?vue&type=script&lang=js&"
export * from "./CopyCandidateFrom.vue?vue&type=script&lang=js&"
import style0 from "./CopyCandidateFrom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports